import { createContext, useContext, type ReactNode } from 'react';

const PageHeaderIconContext = createContext<ReactNode>(undefined);

/** 화면의 아이콘 선택은 앱이 소유하며 공용 헤더에는 장식 요소만 전달합니다. */
export function PageHeaderIconProvider({ icon, children }: { icon: ReactNode; children: ReactNode }) {
  return <PageHeaderIconContext.Provider value={icon}>{children}</PageHeaderIconContext.Provider>;
}

export function usePageHeaderIcon() {
  return useContext(PageHeaderIconContext);
}
